export default function FloatLabel(selector) {

  // add active class and placeholder
  function handleFocus(e) {
    const $target = $(e.target);
    $target.closest(selector).addClass('active')
    if ($target.attr('data-placeholder')) {
      $target.attr('placeholder', $target.attr('data-placeholder'));
    }
  };

  // remove active class and placeholder
  function handleInput(e) {
    const $target = $(e.target);
    if ($target.val()) {
      $target.closest(selector).addClass('active')
      $target.removeAttr('placeholder');
    } else {
      $target.closest(selector).removeClass('active')
      if ($target.attr('data-placeholder')) {
        $target.attr('placeholder', $target.attr('data-placeholder'));
      }
    }
  };

  // register events
  function bindEvents($input) {
    $input.on('focus', handleFocus);
    $input.on('blur', handleInput);
    $input.on('input', handleInput);
  }

  // get DOM elements
  function init(selector) {
    const $floatContainers = $(selector);

    $floatContainers.each(function (i, element) {
      if ($(element).hasClass('_float-container')) return
      $(element).addClass('_float-container');
      let $input = $(element).find('input:not(.ignore-float), textarea')
      if ($input.length === 0) return
      if ($input.val() || $input.is(":focus")) {
        $(element).addClass('active');
      }

      bindEvents($input);
    });

    // Browser password autofill floating label fix
    setTimeout(function () {
      $floatContainers.each(function (i, element) {
        if ($(element).find('input:-webkit-autofill, textarea:-webkit-autofill').length > 0) {
          $(element).addClass('active');
        }
      });
    }, 1000);

  };


  init(selector);

  return this
}
